// @vendors
import React from "react";
import { useTranslation } from "react-i18next";

// @types
import { ServiceRequest } from "../../../../types/request.types";

interface PeopleServiceCardProps {
  service: ServiceRequest;
  onClick: () => void;
}

const PeopleServiceCard: React.FC<PeopleServiceCardProps> = ({ service, onClick }) => {
  const { t } = useTranslation();

  const getStatusClass = (requestStatus: string | number) => {
    if (requestStatus === "ACTIVE" || "COMPLETED") return "bg-bgSuccess text-textOnSuccess";
    return "bg-bgDisabled text-textDisabled";
  }

  console.log(service)

  return (
    <div
      className="flex flex-col gap-2 items-center justify-between p-4 bg-cBackground dark:bg-dark-cBackground rounded-lg shadow-md hover:shadow-lg select-none transition dark:border border-[#717171]"
    //onClick={onClick}
    >
      <section className="w-full flex flex-col md:flex-row gap-2 items-center">
        <div className="w-full flex flex-col md:flex-row gap-2 items-center gap-4">
          <img
            src={`https://eu.ui-avatars.com/api/?name=${service?.customer?.names || 'User'}`}
            alt={service?.customer?.names}
            className="w-12 h-12 rounded-full object-cover"
          />
          <div>
            <p className="font-bold flex justify-center md:justify-start dark:text-dark-cText/80">
              {`${service?.customer?.names || ''} ${service?.customer?.lastNames || ''}`}
            </p>
            {service?.services?.length
              ? service?.services.map((item) => (
                <p className="text-sm text-cTextSecondary dark:text-dark-cText/60">
                  {item?.name || 'Sin servicio'}.
                </p>
              ))
              : null
            }
            <p className="text-xs text-cTextSecondary dark:text-dark-cText/50">
              {/* {formatLocalDate(service?.requestDate)}  */}{new Date(service?.customer.createdAt).toLocaleDateString()}
            </p>
          </div>
        </div>
        <div>
          <button
            className={`px-4 py-1 text-sm font-medium rounded-md ${getStatusClass(service?.serviceRequestStatus)}`}
            onClick={onClick}
          >
            {t("professional.services.openService")}
          </button>
        </div>
      </section>

      {(service?.serviceRequestStatus === 7 || service?.serviceRequestStatus === 'PENDING_COMPLETED') &&
        <p className="w-full flex justify-center text-[12px] text-[#FF6161] font-bold">
          {t("professional.services.serviceProcessCompletion")}
        </p>
      }
    </div>
  );
};

export default PeopleServiceCard;
